import React from "react";
import { useRouter } from "next/router";
import { ItemsContainer, NavigationItem } from "@navigation/TopNavigation/TabBar/TabBar.styled";
import { episodeUrlPrefix } from "@constants/consts";
import { useHostConfig } from "@utils/common/getHostConfig";
import * as Styled from "./SeriesTabBar.styled";

const SeriesTabBar: React.FC = () => {
  const { allowedSeries } = useHostConfig();

  const {
    query: { seriesSlug },
  } = useRouter();

  return (
    <Styled.SeriesTabBarContainer>
      <Styled.SeriesTabBarContent>
        <ItemsContainer>
          {allowedSeries?.map(({ title, id, slug }) => (
            <NavigationItem
              key={id}
              data-text={title}
              aria-current={seriesSlug === slug}
              href={`/${episodeUrlPrefix}/${slug}`}
            >
              {title}
            </NavigationItem>
          ))}
        </ItemsContainer>
      </Styled.SeriesTabBarContent>
    </Styled.SeriesTabBarContainer>
  );
};

export default SeriesTabBar;
